import { ChipsideComponent } from "../chipside-component";

export class Header extends ChipsideComponent {
	static observedAttributes = ["size"];

	constructor() {
		super();

		this.size = this.getAttribute("size") ?? "1";
		this.element = this.getAttribute("element") ?? "div";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents(this.element, this.childNodes, {
			className: `heading--size${this.size}`
		}));
	}

	attributeChanged(name, oldValue, newValue) {
		if (name === "size") {
			this.firstElementChild.classList.remove(`heading--size${oldValue}`);
			this.firstElementChild.classList.add(`heading--size${newValue}`);
		}
	}

	SetText(text) {
		if (this.firstElementChild) {
			this.firstElementChild.textContent = text;
		} else {
			this.textContent = text;
		}
	}
}